export const breadCrumbValues = [{ name: 'Home', url: '/' },
{ name: 'Profiles & Preferences', url: '/Profile' },
{ name: 'Security Preferences', url: '/SecurityPreferences' }
];
export const pageHeaderName = "Change Sign in Method to Soft Token";
export const downloadLabel = "Download the Token Generation Application from the below link and enter the Token Details";
export const optionalMessage = '* All fields are required unless mentioned optional'
